<template>
  <ion-page>
    <!-- cabecera con buscador integrada (estilo Picking) -->
    <CabeceraComponentBackSearch
      :pdv="pdv"
      :isIOS="isIOS"
      :titulo="`Inv. ${this.$filters.formatNum2Date(fecinv)} (${clasif})`"
      color="primary"
      previo="inventarios"
      v-model="filtro_busqueda"
      :debounceMs="debounceMs"
      :placeholder="'Buscar por UBI o filtrar materiales'"
      @search-start="onSearchStart"
      @search-change="filtroInputSearch"
    />

    <!-- Barra superior con segmento de filtro (Pendientes/Reabierto/Aprobado/Cerrado/Todos) al estilo Picking -->
    <ion-header class="segment-header">
      <ion-toolbar color="primary" class="top segmento" style="padding: 0 5px 0 5px">
        <ion-segment v-model="segmentFiltro" mode="ios" color="primary" class="todas" @ionChange="aplicarFiltros">
          <ion-segment-button value="pendientes">{{ inventario_estados.pendientes.texto }}</ion-segment-button>
          <ion-segment-button value="reabierto">{{ inventario_estados.reabierto.texto }}</ion-segment-button>
          <ion-segment-button value="aprobado">{{ inventario_estados.aprobado.texto }}</ion-segment-button>
          <ion-segment-button value="cerrado">{{ inventario_estados.cerrado.texto }}</ion-segment-button>
          <ion-segment-button value="todos">Todos</ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <!-- Indicador de búsqueda mientras se aplica el filtro -->
      <ion-row class="ion-justify-content-center" v-if="isSearching">
        <ion-col size="48" class="ion-align-self-center">
          <ion-progress-bar type="indeterminate" color="primary"></ion-progress-bar>
        </ion-col>
      </ion-row>

      <!-- FAB escáner (indicador) -->
      <ion-fab vertical="top" horizontal="end" slot="fixed">
        <ion-fab-button :key="`scan-activo:${blinker}`" :class="blinker ? 'activo' : 'inactivo'" @click="abrirModalEscaner">
          <i class="fas fa-solid fa-barcode-read muy-grande" :class="blinker ? 'blink' : 'not-blink'" :key="`ion-scan:${blinker}`"></i>
        </ion-fab-button>
      </ion-fab>

      <!-- FAB crear nueva ubicación (abajo derecha) -->
      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button @click="abrirModalNuevaUbicacion" :disabled="cooldownRecarga || inventarioCerrado">
          <span class="icon-stack">
            <i class="fas fa-map-marker-alt base-icon"></i>
            <i class="fas fa-plus overlay-icon"></i>
          </span>
        </ion-fab-button>
      </ion-fab>
      
      <!-- FAB recargar página (abajo izquierda) -->
      <ion-fab vertical="bottom" horizontal="start" slot="fixed">
        <ion-fab-button @click="recargarPagina" :disabled="cooldownRecarga" color="secondary">
          <ion-icon :icon="sync"></ion-icon>
        </ion-fab-button>
      </ion-fab>

      <!-- Spinner de carga mientras consultamos el backend -->
      <ion-row class="spin ion-justify-content-center" v-if="!showme">
        <ion-col v-if="!showme" class="spin ion-align-self-center" size="48">
          <ion-spinner v-if="!showme"></ion-spinner>
        </ion-col>
      </ion-row>

      <div class="container-tablet">

        <!-- Contador sticky al estilo Picking -->
        <div v-if="filtradas && filtradas.length > 0" class="pickings-counter-sticky">
          <ion-button expand="block" fill="outline" size="large" class="trigger_scan">
            <ion-title>
              <ion-text class="ion-text-wrap estrecho">
                <b>{{ filtradas.length }} Ubicaciones</b>
              </ion-text>
            </ion-title>
          </ion-button>
        </div>

        <!-- Lista virtual con InfiniteScroll (mostrando por lotes hasta 100) -->
        <ion-list v-if="visibleItems && visibleItems.length" style="margin: 0; padding-left: 10px;">
          <ion-row v-for="ubi in visibleItems" :key="ubi.ubi" class="ion-align-items-stretch">
            <ion-col>
              <ion-item-sliding>
                <ion-item class="ion-no-padding ion-no-margin" :button="puedeAbrir(ubi)" :detail="loadingUbicacion !== ubi.ubi && puedeAbrir(ubi)" @click="abrirUbicacion(ubi)">
                  <ion-spinner v-if="loadingUbicacion === ubi.ubi" slot="end" color="primary"></ion-spinner>
                  <ion-row>
                    <ion-col size="16" class="ion-align-self-center">
                      <p class="titulo">{{ ubi.ubi }}</p>
                      <div class="lote oscuro">{{ ubi.nomubi || '' }}</div>
                      <div class="lote primary" v-if="ubi.usr && estadoTextoUbi(ubi) !== inventario_estados.pendientes.texto && estadoTextoUbi(ubi) !== inventario_estados.reabierto.texto">Contado por: {{ ubi.usrName || ubi.usr }}</div>
                      <div class="lote fracaso" v-if="ubi.blqUsr">Bloqueado por: {{ ubi.blqUsrName || ubi.blqUsr }}</div>
                    </ion-col>
                    <ion-col size="16" class="ion-align-self-center ion-text-center">
                      <InventarioEstadoRatio :v1="valorSegmento(ubi)" :v2="ubi.lineas || 0" :estado="estadoTextoUbi(ubi)" />
                    </ion-col>
                    <ion-col size="16" class="ion-align-self-center ion-text-center">
                      <div class="lote oscuro">Dif. Stock</div>
                      <small class="dif" :class="getDifColorValor(ubi)">{{ this.$filters.sDecimal0(ubi.dif_valor || 0) }}€</small>
                    </ion-col>
                  </ion-row>
                </ion-item>
                <ion-item-options side="start" v-if="mostrarDesbloqueo(ubi)">
                  <ion-item-option color="warning" @click="desbloquearUbicacion(ubi)">
                    <ion-icon slot="bottom" class="muy-grande" :icon="lockOpenOutline"></ion-icon>
                    <span class="boton-opciones">Desbloquear</span>
                  </ion-item-option>
                </ion-item-options>
                <ion-item-options side="end" v-if="puedeReabrir(ubi)">
                  <ion-item-option color="warning" @click="reabrirUbicacion(ubi)">
                    <ion-icon slot="bottom" class="muy-grande" :icon="arrowUndoSharp"></ion-icon>
                    <span class="boton-opciones">Reabrir</span>
                  </ion-item-option>
                </ion-item-options>
              </ion-item-sliding>
            </ion-col>
          </ion-row>
          <!-- Carga incremental -->
          <ion-infinite-scroll threshold="100px" @ionInfinite="onIonInfinite" :disabled="!puedeCargarMas">
            <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="Cargando más ubicaciones..."></ion-infinite-scroll-content>
          </ion-infinite-scroll>
        </ion-list>
        
      </div>

      <div v-if="visibleItems && visibleItems.length === 0 && showme" style="display: flex; flex: 1 1 auto; height: 100%;" class="ion-justify-content-center">
        <!-- Hacer un aviso sin ion-card, solo texto con un header y un body -->
        <div class="ion-align-self-center">
          <h2>Sin datos en este segmento</h2>
          <p>Sin datos para la fecha seleccionada o filtros aplicados.</p>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import CabeceraComponentBackSearch from '@/components/CabeceraComponentBackSearch.vue'
import { lockOpenOutline, arrowUndoSharp, sync } from 'ionicons/icons'
import eventBus from '@/event-bus'
import { openToast, openAlertaBinaria } from '@/utilities/services/alert-utilities'
import InventarioEstadoRatio from '@/components/InventarioEstadoRatio.vue'
import { modalController } from '@ionic/vue'
import AppScanModal from '@/components/scanner/AppScanModal.vue'
import { inventario_estados, esUbicacion } from '@/utilities/global-constants'
import { scanGenericStart, scanGenericStop } from '@/utilities/scanner/scan-generic'
import InventarioSeleccionProductoModal from '@/components/search/inventario-seleccion-producto-modal.vue'
import SeleccionUbicacionModal from '@/components/ubicaciones/SeleccionUbicacionModal.vue'

export default defineComponent({
  name: 'InventarioDetallePage',
  components: { CabeceraComponentBackSearch, InventarioEstadoRatio },
  // Ruta: '/inventario-detalle/:pdv/:fecinv/:clasif' con props:true en el router
  props: ['pdv', 'fecinv', 'clasif'],
  data () {
    return {
      lockOpenOutline,
      arrowUndoSharp,
      sync,
      cooldownRecarga: false,
      isIOS: this.$route.meta.isIOS,
      ubiku_rol: this.$route.meta.racrol,
      showme: false,
      detalle: [],
      filtro_busqueda: '',
      searchSpec: null,
      segmentFiltro: 'pendientes', // por defecto mostramos pendientes
      filtradas: [],
      visibleItems: [],
      batchSize: 30, // tamaño de lote para infinite scroll (cargar 100 en cada lote)
      blinker: false,
      // identificador para el canal de eventos del escáner genérico de PDA
      element_id: 'inventario-detalle-scan',
      inventario_estados,
      isSearching: false,
      debounceMs: 500,
      loadingUbicacion: null,
      lastScanValue: '',
      lastScanTs: 0,
      scanCooldownMs: 800,
      sseInv: null
    }
  },
  async mounted () {
    // Restaurar estado desde query params (Petición usuario: mantener filtros al volver)
    if (this.$route.query.segment) {
      this.segmentFiltro = this.$route.query.segment
    }
    if (this.$route.query.f) {
      this.filtro_busqueda = this.$route.query.f
      // Simulamos la entrada para generar el searchSpec si es necesario, 
      // aunque filtroInputSearch maneja strings directos también.
      this.filtroInputSearch(this.filtro_busqueda)
    }

    // bloqueamos back y mostramos spinner mientras cargamos
    this.$NoBackNavigator()
    eventBus().emitter.once('transicion', () => (this.showme = false))
    await this.cargarDetalle()
    this.showme = true
    try {
      const base = this.$http?.defaults?.baseURL || ''
      const provider = (this.$route?.meta?.provider) || 'google'
      const key = this.$http?.defaults?.headers?.['key']
      const qs = `?dev=${encodeURIComponent(this.$deviceUuid)}&ml=${encodeURIComponent(this.$current_user||'')}&wn=${encodeURIComponent(this.$wnumber||'')}&provider=${encodeURIComponent(provider)}&key=${encodeURIComponent(key||'')}`
      const url = `${base}/inventario_stream/${this.pdv}/${this.fecinv}/${encodeURIComponent(this.clasif||'00')}${qs}`
      this.sseInv = new EventSource(url)
      this.sseInv.addEventListener('block', (ev) => {
        try {
          const d = JSON.parse(ev.data||'{}')
          const ubi = String(d?.ubicacion||'')
          if (!ubi) return
          const idx = (this.detalle||[]).findIndex(it => String(it.ubi) === ubi)
          if (idx >= 0) {
            const it = this.detalle[idx]
            it.blqUsr = d.blqUsr || it.blqUsr || null
            it.blqUsrName = d.blqUsrName || it.blqUsrName || null
            this.aplicarFiltros(true)
          }
        } catch { void 0 }
      })
      this.sseInv.addEventListener('unlock', (ev) => {
        try {
          const d = JSON.parse(ev.data||'{}')
          const ubi = String(d?.ubicacion||'')
          if (!ubi) return
          const idx = (this.detalle||[]).findIndex(it => String(it.ubi) === ubi)
          if (idx >= 0) {
            const it = this.detalle[idx]
            it.blqUsr = null
            it.blqUsrName = null
            this.aplicarFiltros(true)
          }
        } catch { void 0 }
      })
    } catch { void 0 }
    // activamos el escáner genérico para lecturas de PDA que alimenten el buscador
    await this.escaner_generico()
    this.blinker = true
  },
  async unmounted () {
    // detenemos el escáner genérico al salir de la página
    await scanGenericStop(this.element_id)
    try { if (this.sseInv) { this.sseInv.close(); this.sseInv = null } } catch { void 0 }
  },
  watch: {
    segmentFiltro () {
      this.actualizarUrl()
    },
    filtro_busqueda () {
      // Usamos un pequeño debounce para no saturar el historial/router si escribe rápido
      // aunque usamos replace, es mejor no llamar excesivamente.
      if (this.debounceUrl) clearTimeout(this.debounceUrl)
      this.debounceUrl = setTimeout(() => {
        this.actualizarUrl()
      }, 600)
    }
  },
  methods: {
    actualizarUrl () {
      const query = { ...this.$route.query }
      
      // Asignamos valores
      query.segment = this.segmentFiltro
      query.f = this.filtro_busqueda

      // Limpiamos claves con valores vacíos, nulos o undefined para evitar basura en la URL (como &&)
      Object.keys(query).forEach(key => {
        if (query[key] === undefined || query[key] === null || query[key] === '') {
          delete query[key]
        }
      })

      this.$router.replace({ query })
    },
    obtenerBloqueante (ubi, info) {
      const local = ubi && typeof ubi === 'object' ? (ubi.blqUsr || null) : null
      const remoto = info && typeof info === 'object' ? (info.blqUsr || null) : null
      return remoto || local || null
    },
    // determina si se puede abrir la ubicación (solo si no está bloqueada)
    puedeAbrir (ubi) {
      const bloqueada = !!this.obtenerBloqueante(ubi)
      if (bloqueada) return false
      return true
      // Aqui se esperaba inicialmente que solo los gerentes pudieran reabrir y por lo tanto entrar, ahora todo el mundo
      // const esGerente = Number(this.ubiku_rol) >= 10
      // const estado = this.estadoTextoUbi(ubi)
      // return /*esGerente || */estado === inventario_estados.pendientes.texto || estado === inventario_estados.reabierto.texto
    },
    // puede reabrir cualquier usuario si estado 'Aprobado' (A)
    puedeReabrir (ubi) {
      // const esGerente = Number(this.ubiku_rol) >= 10
      const estado = this.estadoTextoUbi(ubi)
      return estado === inventario_estados.aprobado.texto // && esGerente
    },
    // muestra opción de desbloqueo si hay bloqueo y el usuario es gerente (rol 10)
    mostrarDesbloqueo (ubi) {
      const bloqueante = this.obtenerBloqueante(ubi)
      // const esGerente = Number(this.ubiku_rol) >= 10
      return !!bloqueante // && esGerente
    },
    // handler de apertura delega la validación a goUbicacion (según petición)
    abrirUbicacion (ubi) {
      const bloqueante = this.obtenerBloqueante(ubi)
      if (bloqueante) { openToast(`Ubicación bloqueada por ${ubi.blqUsrName || bloqueante}`); return }
      if (!this.puedeAbrir(ubi)) { openToast('Acción no permitida para tu perfil') ; return }
      this.goUbicacion(ubi)
    },
    async recargarPagina () {
      if (this.cooldownRecarga) return
      // activamos cooldown
      this.cooldownRecarga = true
      // Feedback visual inmediato: limpiamos listas y mostramos spinner
      this.showme = false
      this.detalle = []
      this.filtradas = []
      this.visibleItems = []
      
      // recargamos datos
      await this.cargarDetalle()
      
      // mostramos contenido de nuevo
      this.showme = true
      
      // Timer de 10 segundos para rehabilitar el botón
      setTimeout(() => {
        this.cooldownRecarga = false
      }, 10000)
    },
    async abrirModalNuevaUbicacion () {
      try {
        const modal = await modalController.create({
          component: SeleccionUbicacionModal,
          componentProps: { zonaInit: 'ZOA', pasilloInit: 0, estanteInit: 0, alturaInit: 0 }
        })
        await modal.present()
        const { data, role } = await modal.onWillDismiss()
        if (role !== 'confirm' || !data) return
        const ubi = String(data).trim().toUpperCase()
        const existe = (this.detalle || []).some(it => String(it.ubi) === ubi)
        if (existe) {
          const ok = await openAlertaBinaria(
            'Ubicación ya existe',
            `La ubicación ${ubi} ya existe en este inventario. ¿Quieres abrirla?`,
            'Cancelar',
            'Abrir'
          )
          if (ok) { this.goUbicacion(ubi); return }
          return
        }
        await this.abrirModalCreacionUbicacion(ubi)
      } catch (ex) {
        openToast('No se pudo abrir el creador de ubicación')
        console.log(ex)
      }
    },
    async cargarDetalle () {
      if (!this.pdv || !this.fecinv || !this.clasif) { return }
      try {
        const url = `/inventario_detalle/${this.pdv}/${this.fecinv}/${this.clasif}`
        const res = await this.$http.get(url)
        const data = Array.isArray(res.data) ? res.data : []
        // agregamos contadores derivados si existen campos base (defensivo por variabilidad de API)
        this.detalle = data.map(it => ({
          ubi: it.ubi || it.ubicacion || 'SIN_UBI',
          nomubi: it.nomubi || it.nombre_ubi || '',
          lineas: it.lineas || it.num_lineas || 0,
          pendientes: it.pendientes || 0,
          reabiertos: it.reabiertos || 0,
          aprobados: it.aprobados || 0,
          cerrados: it.cerrados || 0,
          usr: it.usr || null,              // Usuario que contó (solo en aprobados)
          usrName: it.usrName || null,      // Nombre del usuario que contó
          blqUsr: it.blqUsr || null,
          blqUsrName: it.blqUsrName || null,
          dif_valor: it.dif_valor || it.dif_eur || 0,
          lista_skus: it.lista_skus || []
        }))
        // tras cargar, aplicamos filtros y preparamos la lista virtual
        this.aplicarFiltros(true)
      } catch (ex) {
        openToast('Error cargando detalle de inventario')
        console.log(ex)
      }
    },
    getDifColorValor (it) {
      const v = Number(it?.dif_valor ?? 0)
      if (v === 0) return 'primary'
      return v > 0 ? 'warning' : 'darkdanger'
    },
    async abrirModalEscaner () {
      // modal de escaneo EAN-13 reutilizable
      try {
        this.blinker = false
        const modal = await modalController.create({
          component: AppScanModal,
          componentProps: { titulo: 'Escanea un código', elementId: 'inventario-detalle-scan' }
        })
        await modal.present()
        const { data, role } = await modal.onWillDismiss()
        this.blinker = true
        if (role === 'confirm' && typeof data === 'string') {
          await this.procesarLectura(data)
        }
      } catch (ex) {
        this.blinker = true
        openToast('No se pudo abrir el escáner')
        console.log(ex)
      }
    },
    // listener de lecturas del escáner genérico de PDA: pone el texto en el buscador y aplica filtros
    async lectorEventosGenericos () {
      const self = this
      eventBus().emitter.off(`lectura_generica:${this.element_id}`)
      eventBus().emitter.once(`lectura_generica:${this.element_id}`, async (input_scaner_in) => {
        // normalizamos caracteres especiales de algunas PDAs
        const input_scaner = String(input_scaner_in || '').replace(/\?/g, '_')
        if (self.lastScanValue === input_scaner && (Date.now() - self.lastScanTs) < self.scanCooldownMs) {
          self.lectorEventosGenericos()
          return
        }
        self.lastScanValue = input_scaner
        self.lastScanTs = Date.now()
        // procesamos la lectura para detectar si es una nueva ubicación
        await self.procesarLectura(input_scaner)
        // nos re-suscribimos para siguientes lecturas sin requerir interacción
        self.lectorEventosGenericos()
      })
    },
    // activación del escáner genérico reutilizable: reinicia, activa y suscribe listener
    async escaner_generico () {
      await scanGenericStop(this.element_id)
      await scanGenericStart(this.element_id, 'inventario-detalle')
      await this.lectorEventosGenericos()
    },
    async procesarLectura (codigo) {
      if (!codigo) return
      // Normalizamos a mayúsculas para evitar duplicados por case-sensitivity
      const ubi = codigo.trim().toUpperCase()
      // 1. Buscar si existe en el detalle
      const existe = (this.detalle || []).find(it => it.ubi === ubi)
      
      // Si existe, filtramos (comportamiento original)
      if (existe) {
        this.filtro_busqueda = ubi
        this.filtroInputSearch(ubi)
        return
      }

      // 2. Si no existe, validamos regex de ubicación y estado inventario
      if (!this.inventarioCerrado && esUbicacion.test(ubi)) {
        // Alerta de creación
        const ok = await openAlertaBinaria(
          `Ubicación ${ubi} no encontrada`,
          `Vemos que la ubicacion no existe, quieres añadirla al inventario? No se añadirá a ubiku hasta que se confirme el inventario.`,
          'No',
          'Sí'
        )
        if (ok) {
          this.abrirModalCreacionUbicacion(ubi)
        }
      } else {
        // Si no es ubicación válida o no estamos en estado pendiente, filtramos igual (quizás es artículo)
        this.filtro_busqueda = ubi
        this.filtroInputSearch(ubi)
      }
    },
    async abrirModalCreacionUbicacion (ubicacion) {
      await scanGenericStop(this.element_id)
      const modal = await modalController.create({
        component: InventarioSeleccionProductoModal,
        componentProps: {
          title: `Añadir artículo a ${ubicacion}`,
          pdv: this.pdv,
          allowMultiple: false // Por ahora mantenemos simple selección, como en InventarioUbicacionPage
        }
      })
      
      modal.onDidDismiss().then(async (result) => {
        const data = result.data
        if (data && data.item) {
          await this.crearUbicacion(ubicacion, data.item)
        }
        await scanGenericStart(this.element_id, 'inventario-detalle')
        await this.lectorEventosGenericos()
      })
      
      this.filtro_busqueda = ''
      return await modal.present()
    },
    async crearUbicacion (ubicacion, articulo) {
      try {
        const payload = {
          fecinv: this.fecinv,
          clasif: this.clasif || '00',
          ubicacion: ubicacion,
          sku: articulo.sku,
          numlot: articulo.lote || 'N',
          stoalm: Number(articulo.stoalm || 0),
          // El procedure calculará is_primaria
        }
        
        // Llamada al nuevo endpoint
        const res = await this.$http.post(`/inventario_crear_ubicacion/${this.pdv}`, payload)
        
        // Validación de respuesta del backend (homogeneización de errores)
        const data = (res && res.data) || {}
        if (Object.keys(data).length === 0 || data.status === 0 || data.error) {
          throw { response: { data: { message: data.message || data.alert || 'Error al crear la ubicación.' } } }
        }
        
        openToast('Ubicación creada correctamente')
        
        // Recargar detalle y navegar a la nueva ubicación
        await this.cargarDetalle()
        this.goUbicacion(ubicacion)
        
      } catch (ex) {
        console.error(ex)
        const msg = ex.response?.data?.message || ex.response?.data?.alert || 'Error al crear la ubicación'
        openToast(msg)
      }
    },
    // manejador del cambio en el buscador de la cabecera
    filtroInputSearch (q) {
      if (q && typeof q === 'object' && q.apply) {
        this.searchSpec = q
        this.filtro_busqueda = String(q.raw || '').trim()
      } else {
        // Si viene un string (ej: URL o escáner), construimos un searchSpec sintético
        const raw = String(q || '').trim()
        if (raw.length > 0) {
          const norm = raw.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          this.searchSpec = {
            apply: true,
            isEmpty: false,
            raw: raw,
            norm: norm,
            tokens: norm.split(/\s+/).filter(t => t.length > 0)
          }
          this.filtro_busqueda = raw
        } else {
          this.searchSpec = null
          this.filtro_busqueda = ''
        }
      }
      this.aplicarFiltros(true)
    },
    onSearchStart () { this.isSearching = true },
    aplicarFiltros (reiniciar = false) {
      const spec = this.searchSpec
      const textoItem = (it) => {
        const estado = this.estadoTextoUbi(it) || ''
        const bloqueado = it.blqUsr || it.blqUsrName ? `Bloqueado por: ${it.blqUsrName || it.blqUsr}` : ''
        const contadores = `${it.pendientes || 0} ${it.lineas || 0} ${it.reabiertos || 0} ${it.aprobados || 0} ${it.cerrados || 0}`
        const nomubi = it.nomubi || ''
        // Añade los terminos que quieras en el return
        return `${it.ubi} ${contadores} ${estado} ${bloqueado} ${nomubi}`
      }
      const porTexto = (it) => {
        if (!spec || spec.isEmpty) return true
        const toks = Array.isArray(spec.tokens) && spec.tokens.length > 0 ? spec.tokens : [spec.norm || '']
        const esc = toks.map(t => String(t).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        const re = new RegExp(esc.join('.*'), 'i')
        if (re.test(textoItem(it))) return true
        const arr = it.lista_skus
        if (Array.isArray(arr)) {
          const coincide = arr.some(v => {
            if (typeof v === 'string') return re.test(String(v || ''))
            if (v && typeof v === 'object') {
              const sku = String(v.sku || v.SKU || '')
              const nombre = String(v.nombre || v.NOMBRE || '')
              const numlot = String(v.numlot || v.NUMLOT || '')
              return re.test(sku) || re.test(nombre) || re.test(numlot)
            }
            return false
          })
          if (coincide) return true
        }
        return false
      }
      // Filtro por segmento: incluir solo ubicaciones con conteo > 0 en el segmento seleccionado
      const porSegmento = (it) => {
        if (this.segmentFiltro === 'todos') return true
        if (this.segmentFiltro === 'pendientes') return Number(it?.pendientes ?? 0) > 0
        if (this.segmentFiltro === 'reabierto') return Number(it?.reabiertos ?? 0) > 0
        if (this.segmentFiltro === 'aprobado') return Number(it?.aprobados ?? 0) > 0
        if (this.segmentFiltro === 'cerrado') return Number(it?.cerrados ?? 0) > 0
        return true
      }
      this.filtradas = (this.detalle || []).filter(it => porTexto(it) && porSegmento(it))
      if (reiniciar) {
        // Reiniciamos la lista visible al primer lote (100 elementos máximo por lote)
        const inicial = Math.min(this.batchSize, this.filtradas.length)
        this.visibleItems = this.filtradas.slice(0, inicial)
      } else {
        // Mantenemos visibleItems dentro de límites del total filtrado
        const limite = Math.min(this.visibleItems.length, this.filtradas.length)
        this.visibleItems = this.filtradas.slice(0, limite)
      }
      this.isSearching = false
    },
    valorSegmento (it) {
      if (this.segmentFiltro === 'pendientes') return Number(it?.pendientes ?? 0)
      if (this.segmentFiltro === 'reabierto') return Number(it?.reabiertos ?? 0)
      if (this.segmentFiltro === 'aprobado') return Number(it?.aprobados ?? 0)
      if (this.segmentFiltro === 'cerrado') return Number(it?.cerrados ?? 0)
      if (this.segmentFiltro === 'todos') {
        const e = this.estadoTextoUbi(it)
        if (e === inventario_estados.aprobado.texto) return Number(it?.aprobados ?? 0)
        if (e === inventario_estados.reabierto.texto) return Number(it?.reabiertos ?? 0)
        if (e === inventario_estados.cerrado.texto) return Number(it?.cerrados ?? 0)
        return Number(it?.pendientes ?? 0)
      }
      return Number(it?.pendientes ?? 0)
    },
    // calcula el estado textual de una ubicación según contadores
    estadoTextoUbi (it) {
      const lineas = Number(it?.lineas ?? 0)
      const pendientes = Number(it?.pendientes ?? 0)
      const aprobados = Number(it?.aprobados ?? 0)
      const cerrados = Number(it?.cerrados ?? 0)
      let k = 'pendientes'
      if (cerrados > 0 && cerrados >= lineas) k = 'cerrado'
      else if (pendientes === 0 && aprobados === lineas && lineas > 0) k = 'aprobado'
      else if (pendientes === 0 && aprobados < lineas) k = 'reabierto'
      return inventario_estados[k].texto
    },
    // evento de InfiniteScroll para añadir más elementos visibles por lotes
    async onIonInfinite (ev) {
      try {
        const current = this.visibleItems.length
        const siguiente = Math.min(current + this.batchSize, this.filtradas.length)
        // Si no hay más para agregar, deshabilitamos
        if (siguiente <= current) {
          ev.target.disabled = true
        } else {
          this.visibleItems = this.filtradas.slice(0, siguiente)
        }
      } finally {
        // Importante: completar el evento para que Ionic quite el spinner
        ev.target.complete()
      }
    },
    async goUbicacion (ubi) {
      const ubic = typeof ubi === 'string' ? ubi : ubi.ubi
      if (this.loadingUbicacion) return
      const previo = this.obtenerBloqueante(ubi)
      if (previo) {
        openToast(`Ubicación bloqueada por ${previo}`)
        return
      }
      this.loadingUbicacion = ubic
      try {
        const res = await this.$http.get(`/inventario_ubicacion/${this.pdv}/${this.fecinv}/${this.clasif}/${ubic}`)
        const info = Array.isArray(res.data) ? (res.data[0] || {}) : (res.data || {})
        const bloqueante = this.obtenerBloqueante(ubi, info)
        if (bloqueante) {
          openToast(`Ubicación bloqueada por ${bloqueante}`)
          this.loadingUbicacion = null
          return
        }
      } catch (ex) {
        console.log('No se pudo verificar bloqueo antes de navegar', ex)
      }
      this.$router.push({ name: 'inventario_ubicacion', params: { pdv: this.pdv, fecinv: this.fecinv, clasif: this.clasif, ubi: ubic } })
        .catch(() => { this.loadingUbicacion = null })
        .then(() => { setTimeout(() => { this.loadingUbicacion = null }, 1000) })
    },
    // petición para liberar el bloqueo de la ubicación desde el detalle
    async desbloquearUbicacion (ubi) {
      try {
        const ubic = typeof ubi === 'string' ? ubi : ubi.ubi
        const res = await this.$http.post(`/inventario_ubicacion/${this.pdv}/${this.fecinv}/${this.clasif}/${ubic}`, { blqUsr: null, ubiku_rol: Number(this.ubiku_rol) })
        const data = (res && res.data) || {}
        if (Object.keys(data).length === 0 || data.status === 0 || data.error) {
          throw { response: { data: { message: data.message || data.alert || 'No se pudo desbloquear la ubicación.' } } }
        }
        openToast('Ubicación desbloqueada')
        await this.cargarDetalle()
      } catch (ex) {
        const msg = ex.response?.data?.message || ex.response?.data?.alert || 'No se pudo desbloquear la ubicación'
        openToast(msg)
        console.log(ex)
      }
    },
    async reabrirUbicacion (ubi) {
      try {
        const ok = await openAlertaBinaria(
          'Reabrir ubicación',
          'Reabrir pondrá la ubicación en REABIERTO para poder contabilizar de nuevo (sin tocar cantidades).',
          'Cancelar',
          'Reabrir'
        )
        if (!ok) return
        const id = typeof ubi === 'string' ? ubi : ubi.ubi
        // Reabrimos a estado R conservando lo contado
        const res = await this.$http.post(`/inventario_reabrir_sel/${this.pdv}`, { fecinv: this.fecinv, ubis: [id], clasif: this.clasif || '00' })
        const data = (res && res.data) || {}
        if (Object.keys(data).length === 0 || data.status === 0 || data.error) {
          throw { response: { data: { message: data.message || data.alert || 'No se pudo reabrir la ubicación.' } } }
        }
        openToast('Ubicación reabierta')
        await this.cargarDetalle()
      } catch (ex) {
        const msg = ex.response?.data?.message || ex.response?.data?.alert || 'No se pudo reabrir la ubicación'
        openToast(msg)
        console.log(ex)
      }
    },
  },
  computed: {
    // control para habilitar/deshabilitar InfiniteScroll
    puedeCargarMas () {
      return this.visibleItems.length < this.filtradas.length
    },
    // inventario cerrado: todas las líneas de todas las ubicaciones en estado C
    inventarioCerrado () {
      const ds = this.detalle || []
      return ds.length > 0 && ds.every(it => Number(it.cerrados || 0) >= Number(it.lineas || 0))
    },
  }
})
</script>

<style scoped lang="scss">

@import "@/theme/footer-styles.scss";

.izquierda { text-align: left; }
.muy-grande { font-size: 1.4rem; }
.titulo { font-size: 1rem; font-weight: bold; margin: 0; }
.lote.oscuro { font-size: 0.9rem; color: var(--ion-color-medium); }
.lote.aviso { font-size: 0.9rem; color: var(--ion-color-warning); }
.lote.exito { font-size: 0.9rem; color: var(--ion-color-success); }
.lote.fracaso { font-size: 0.9rem; color: var(--ion-color-danger); }
.lote.primary { font-size: 0.9rem; color: var(--ion-color-primary); }
ion-text.fake-titulo { color: var(--ion-color-primary) !important; }
span.boton-opciones { font-size: larger !important; font-weight: bold !important; }
/* estilos reutilizados del estilo Picking para header contador */
/* Estilos para sticky header del contador de pickings */
.pickings-counter-sticky {
  position: sticky;
  top: 0;
  z-index: 15;
  background-color: white;
  padding: 15px 70px;
  margin: 0;
  width: 100%;
}
.container-tablet { width: 100%; max-width: 768px; margin: 0 auto; scrollbar-width: none; }
.segment-header { position: sticky; top: 0; z-index: 9; }
.dif.success { color: var(--ion-color-success); }
.dif.warning { color: var(--ion-color-warning); }
.dif.darkdanger { color: var(--ion-color-danger); }
.dif.primary { color: var(--ion-color-primary); }
ion-segment.todas {
  width: 100% !important; 
  margin-left: 6px !important;
  margin-right: 6px !important;
  padding: 3px 3px 16px 3px !important; 
}
ion-toolbar.segmento {
  height: 3rem !important; 
}
.in-segment-color {
  color: var(--ion-color-blanco) !important; 
}
.segment-button-checked {
  color: var(--ion-color-primary) !important; 
  font-weight: bold !important; 
}

/* Icono apilado para el FAB de nueva ubicación */
.icon-stack { position: relative; display: inline-block; width: 1.6rem; height: 1.6rem; }
.icon-stack .base-icon { font-size: 1.6rem; }
.icon-stack .overlay-icon { position: absolute; right: -0.5rem; top: -0.15rem; font-size: 0.8rem; color: var(--ion-color-primary); background: #fff; border-radius: 50%; padding: 0.05rem; box-shadow: 0 0 0 1px rgba(0,0,0,0.05); }

</style>
